export default __webpack_public_path__ + "static/media/sun_texture.4b569137.jpg";